export default __webpack_public_path__ + "static/media/fastened.92d00170.svg";